import {
  stringifyParams
} from 'helpers/query_params';

import underscored from 'underscore.string/underscored';

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('invoicesList', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/invoices/invoices_list.html.slim'),
    scope: {
      contact: '=',
      familyContact: '=',
      isSharingPayments: '=',
      addCreditVoucher: '&'
    },
    controller: ["$scope", "$rootScope", "$stateParams", "$state", "$window", "$filter", "$modal", "$http", "$timeout", "EmploymentService", "TableService", "MembershipPlans", "Contacts", "Locations", "GTMService", "MembershipPlanCategories", "Invoices", "BulkInvoices", "InvoiceRescheduleService", "MasqueradingService", "FeatureAvailabilityService", "bulkMessageService", "MessageService", "flash", "CwStorage", "loadingAnimation", "Sales", "InvoiceFailureReasonService", "ReactModal", "SkipInvoiceService", function($scope, $rootScope, $stateParams, $state, $window, $filter, $modal, $http, $timeout, EmploymentService, TableService, MembershipPlans, Contacts, Locations, GTMService, MembershipPlanCategories, Invoices, BulkInvoices, InvoiceRescheduleService, MasqueradingService, FeatureAvailabilityService, bulkMessageService, MessageService, flash, CwStorage, loadingAnimation, Sales, InvoiceFailureReasonService, ReactModal, SkipInvoiceService) {
      var buildDateFilters, buildDateFiltersObj, buildPresetFilterOptions, bulkStatusChange, cleanedFilters, dashletFirstLoadDone, dashletRequestInFlight, defaultDateFilters, defaultFilters, formatCurrency, getCountOnPage, getSelectableInvoices, getSources, getTotalAmount, gym, gymId, onFiltersChanged, pluralizeInvoice, ref, ref1, reloadTable, remove, storedFilters;
      gymId = $stateParams.gymId;
      $scope.gym = gym = $rootScope.gym;
      $scope.contactId = $stateParams.contactId;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.selectedInvoices = [];
      $scope.bulkRescheduleParams = {};
      $scope.currency_symbol = $rootScope.gym.currency_symbol;
      $scope.paymentStatuses = ['upcoming', 'submitted', 'pending', 'paid', 'failed', 'chargeback', 'skipped', 'process_manually', 'auto_reschedule'];
      $scope.featureNames = featureNames;
      dashletRequestInFlight = false;
      dashletFirstLoadDone = false;
      defaultDateFilters = {
        after: moment().subtract(31, 'days').format('YYYY-MM-DD'),
        before: moment().add(28, 'days').format('YYYY-MM-DD'),
        type: 'due_date',
        beforeKey: 'due_date_before',
        afterKey: 'due_date_after'
      };
      buildPresetFilterOptions = function() {
        var dueNextOptionVisible, isInitialFilters, processManuallyOptionVisible;
        isInitialFilters = _.isEqual($scope.filters, defaultFilters) && _.isEqual($scope.dateFilters, defaultDateFilters);
        dueNextOptionVisible = !isInitialFilters || $scope.selectedPresetFilter === 'due_next';
        processManuallyOptionVisible = !$scope.gym.has_payment_provider;
        return $scope.presetFilterOptions = _.compact([
          {
            value: 'all_failures',
            label: 'All failures'
          },
          {
            value: 'all_skipped',
            label: 'All skipped payments'
          },
          {
            value: 'all_pending',
            label: 'All pending payments'
          },
          processManuallyOptionVisible && {
            value: 'all_process_manually',
            label: 'All payments marked "Process Manually"'
          },
          {
            value: 'successful_payments_14_days',
            label: 'Successful payments (last 14 days)'
          },
          {
            value: 'successful_payments_30_days',
            label: ' Successful payments (last 30 days)'
          },
          {
            value: 'successful_payments_90_days',
            label: 'Successful payments (last 90 days)'
          },
          dueNextOptionVisible && {
            value: 'due_next',
            label: 'Due next / Recently processed'
          }
        ]);
      };
      buildPresetFilterOptions();
      $scope.dateFilters = {
        after: (function() {
          if ($stateParams.status === 'futureRevenue') {
            return moment().format('YYYY-MM-DD');
          } else if ($stateParams.dashletDates) {
            return moment($state.params.dashletDates).format('YYYY-MM-DD');
          } else {
            return moment().subtract(31, 'days').format('YYYY-MM-DD');
          }
        })(),
        before: (function() {
          if ($stateParams.status === 'futureRevenue') {
            return moment($stateParams.dashletDates).format('YYYY-MM-DD');
          } else if ($stateParams.dashletDates) {
            return moment().format('YYYY-MM-DD');
          } else {
            return moment().add(28, 'days').format('YYYY-MM-DD');
          }
        })()
      };
      $scope.dateFilterOptions = _.compact([
        {
          type: 'due_date',
          beforeKey: 'due_date_before',
          afterKey: 'due_date_after'
        },
        {
          type: 'date_paid',
          beforeKey: 'paid_before',
          afterKey: 'paid_after'
        },
        {
          type: 'date_failed',
          beforeKey: 'failed_before',
          afterKey: 'failed_after'
        },
        $scope.gym.uses_ezidebit && {
          type: 'date_settled',
          beforeKey: 'settled_before',
          afterKey: 'settled_after'
        }
      ]);
      $scope.onDateChange = function() {
        $scope.clearSelectedPreset();
        return reloadTable();
      };
      $scope.setDateFilter = function(filter, silent) {
        if (!$scope.dateFilters.type) {
          if ($stateParams.status === 'failed') {
            $scope.dateFilters.type = 'date_failed';
            $scope.dateFilters.beforeKey = 'failed_before';
            $scope.dateFilters.afterKey = 'failed_after';
          } else if ($stateParams.status === 'paid') {
            $scope.dateFilters.type = 'date_paid';
            $scope.dateFilters.beforeKey = 'paid_before';
            $scope.dateFilters.afterKey = 'paid_after';
          } else {
            $scope.dateFilters.type = filter.type;
            $scope.dateFilters.beforeKey = filter.beforeKey;
            $scope.dateFilters.afterKey = filter.afterKey;
          }
        } else {
          $scope.dateFilters.type = filter.type;
          $scope.dateFilters.beforeKey = filter.beforeKey;
          $scope.dateFilters.afterKey = filter.afterKey;
        }
        if (!silent) {
          return $scope.onDateChange();
        }
      };
      $scope.setDateFilter($scope.dateFilterOptions[0], true);
      buildDateFilters = function() {
        var params;
        params = {};
        params[`filters[${$scope.dateFilters.afterKey}]`] = $scope.dateFilters.after;
        params[`filters[${$scope.dateFilters.beforeKey}]`] = $scope.dateFilters.before;
        return params;
      };
      buildDateFiltersObj = function() {
        var params;
        params = {};
        params[$scope.dateFilters.afterKey] = $scope.dateFilters.after;
        params[$scope.dateFilters.beforeKey] = $scope.dateFilters.before;
        return params;
      };
      if (!$scope.contactId) {
        GTMService.trackPage('Payments');
      }
      $scope.selectPreset = function() {
        var presetFilters;
        $scope.dateFilters.after = void 0;
        $scope.dateFilters.before = gym.today;
        presetFilters = angular.extend({}, defaultFilters);
        presetFilters.search = '';
        switch ($scope.selectedPresetFilter) {
          case 'all_failures':
            $scope.setDateFilter($scope.dateFilterOptions[2], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'failed';
            });
            break;
          case 'all_skipped':
            $scope.setDateFilter($scope.dateFilterOptions[0], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'skipped';
            });
            break;
          case 'all_pending':
            $scope.setDateFilter($scope.dateFilterOptions[0], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'pending';
            });
            break;
          case 'all_process_manually':
            $scope.setDateFilter($scope.dateFilterOptions[0], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'process_manually';
            });
            break;
          case 'successful_payments_14_days':
            $scope.dateFilters.after = moment(gym.today).subtract(14, 'days').format('YYYY-MM-DD');
            $scope.setDateFilter($scope.dateFilterOptions[1], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'paid';
            });
            break;
          case 'successful_payments_30_days':
            $scope.dateFilters.after = moment(gym.today).subtract(30, 'days').format('YYYY-MM-DD');
            $scope.setDateFilter($scope.dateFilterOptions[1], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'paid';
            });
            break;
          case 'successful_payments_90_days':
            $scope.dateFilters.after = moment(gym.today).subtract(90, 'days').format('YYYY-MM-DD');
            $scope.setDateFilter($scope.dateFilterOptions[1], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = status === 'paid';
            });
            break;
          case 'due_next':
            $scope.dateFilters.after = moment(gym.today).subtract(31, 'days').format('YYYY-MM-DD');
            $scope.dateFilters.before = moment(gym.today).add(28, 'days').format('YYYY-MM-DD');
            $scope.setDateFilter($scope.dateFilterOptions[0], true);
            $scope.paymentStatuses.forEach(function(status) {
              return presetFilters[status] = true;
            });
        }
        if (_.isEqual($scope.filters, presetFilters)) {
          return reloadTable();
        } else {
          $scope.$emit('invoices:filtersPresetSelected', presetFilters);
          return $scope.setFilters(presetFilters, {
            fromPreset: true
          });
        }
      };
      if (!$scope.gym.uses_submitted_payment_status) {
        $scope.paymentStatuses = _.without($scope.paymentStatuses, 'submitted');
      }
      if (!$scope.gym.uses_chargeback_payment_status) {
        $scope.paymentStatuses = _.without($scope.paymentStatuses, 'chargeback');
      }
      if (!$scope.gym.has_payment_provider) {
        $scope.paymentStatuses = _.without($scope.paymentStatuses, 'auto_reschedule');
      }
      $scope.membershipPlans = MembershipPlans.getList({
        count: 200
      }).$object;
      $scope.locations = [];
      $scope.membershipPlanCategories = [];
      $scope.creditVouchersAvailable = FeatureAvailabilityService.isAvailable('credit_vouchers');
      Locations.getList({
        count: 200
      }).then(function(locations) {
        return $scope.locations = locations.concat({
          id: '-1',
          name: '[No location]'
        });
      });
      MembershipPlanCategories.getList({
        count: 200
      }).then(function(categories) {
        return $scope.membershipPlanCategories = categories.concat({
          id: '-1',
          label: '[No category]'
        });
      });
      $scope.isContactPage = function() {
        return !!$scope.contactId && !$scope.familyContact;
      };
      $rootScope.$on('invoices:list:reload', function() {
        return reloadTable();
      });
      $scope.open = function(invoice, event) {
        event.preventDefault();
        event.stopPropagation();
        return invoice.rescheduling = true;
      };
      $scope.isInvoiceSelected = function(invoice) {
        return _.find($scope.selectedInvoices, function(item) {
          return item.id === invoice.id;
        });
      };
      $scope.toggleSelectableInvoices = function(event) {
        event.preventDefault();
        $scope.selectedInvoices = $scope.selectedInvoices.length ? [] : getSelectableInvoices();
        return $timeout(function() {
          return $scope.isAllInvoicesSelected = !!$scope.selectedInvoices.length;
        });
      };
      $scope.toggleInvoice = function(invoice) {
        if ($scope.isInvoiceSelected(invoice)) {
          $scope.selectedInvoices = _.without($scope.selectedInvoices, invoice);
        } else {
          $scope.selectedInvoices.push(invoice);
        }
        return $scope.isAllInvoicesSelected = getSelectableInvoices().length === $scope.selectedInvoices.length;
      };
      getSelectableInvoices = function() {
        return _.filter($scope.tableParams.data, $scope.isInvoiceSelectable);
      };
      pluralizeInvoice = function() {
        var length;
        length = $scope.selectedInvoices.length;
        if (length > 1) {
          return `${length} invoices`;
        } else {
          return 'this invoice';
        }
      };
      $scope.getFailureReasonTooltipType = function(authorizationMessage) {
        return InvoiceFailureReasonService.getFailureReasonTooltipType(authorizationMessage);
      };
      $scope.displayFailureReasonDetails = function(authorizationMessage) {
        return InvoiceFailureReasonService.displayFailureReasonDetails(authorizationMessage);
      };
      $scope.displayAppliedCredit = function(invoice) {
        var modalInstance;
        return modalInstance = ReactModal.open({
          component: 'DisplayAppliedCreditModal',
          props: {
            invoice: invoice
          }
        });
      };
      $scope.bulkMarkAsSkipped = function() {
        var creditAmount, message, totalCreditAmount;
        message = [`Are you sure you want to skip ${pluralizeInvoice()}?`];
        totalCreditAmount = $scope.selectedInvoices.reduce((acc, item) => {
          if (item.credit_applied_amount) {
            return (+acc + +item.credit_applied_amount).toFixed(2);
          }
          return acc;
        }, 0);
        if (totalCreditAmount > 0) {
          creditAmount = $filter('currency')(totalCreditAmount, $scope.gym.currency_symbol);
          message.push(`Note: a combined total of ${creditAmount} credit has been applied to one or more of these payments. If you wish to remove this credit, please do so from the payment actions menu.`);
        }
        return MessageService.message({
          title: 'Skip invoices',
          message: message,
          confirmButtonText: "Yes"
        }).then(function() {
          return bulkStatusChange({
            property: 'skip'
          });
        });
      };
      $scope.bulkMarkAsPaid = function(type) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/gyms/invoices/bulk_mark_as_paid_modal.html.slim'),
          controller: 'BulkMarkAsPaidCtrl',
          resolve: {
            selectedInvoices: function() {
              return $scope.selectedInvoices;
            },
            type: function() {
              return type;
            },
            bulkStatusChange: function() {
              return bulkStatusChange;
            }
          }
        });
      };
      bulkStatusChange = function(options) {
        var params;
        params = {
          ids: _.map($scope.selectedInvoices, function(invoice) {
            return invoice.id;
          }),
          invoices: {
            approval_date: options.approval_date
          },
          withoutNamespace: true
        };
        params.invoices[options.property] = true;
        if (options.onLoading) {
          options.onLoading();
        }
        loadingAnimation.show();
        return BulkInvoices.doPUT(params).then(function() {
          var invoiceNaming, status;
          status = options.property === 'skip' ? 'skipped' : `paid by ${options.label}`;
          invoiceNaming = params.ids.length > 1 ? 'invoices' : 'invoice';
          flash.success = `The ${invoiceNaming} was successfully marked as ${status}`;
          reloadTable();
          if (options.onSuccess) {
            return options.onSuccess();
          }
        }, function(response) {
          loadingAnimation.hide();
          flash.error = "There was an error processing the request.";
          if (options.onError) {
            return options.onError(response);
          }
        });
      };
      $scope.reschedule = function(invoice) {
        var newDueDate;
        invoice.rootObjectName = 'invoice';
        newDueDate = $filter('stringToDate')(invoice.rescheduled_due_date);
        if ($window.confirm(`Are you sure you want to reschedule this invoice to ${newDueDate}?`)) {
          return InvoiceRescheduleService.reschedule(invoice, reloadTable, $scope.featureNames);
        } else {
          return invoice.rescheduled_due_date = invoice.due_date;
        }
      };
      $scope.bulkReschedule = function() {
        var contactIds, dateLabel, rescheduleDate;
        rescheduleDate = $scope.bulkRescheduleParams.date;
        $scope.bulkRescheduleParams.date = void 0;
        dateLabel = $filter('stringToDate')(rescheduleDate);
        contactIds = _.map($scope.selectedInvoices, function(invoice) {
          return invoice.contact_id;
        });
        $scope.featureNames = featureNames;
        if ($scope.gym.has_payment_provider && moment().isAfter(rescheduleDate, 'day')) {
          flash.error = 'Invoices cannot be rescheduled to a date before today.';
          return;
        }
        if (contactIds.length !== _.uniq(contactIds).length) {
          flash.error = 'Please select at most one payment per member before rescheduling.';
          return;
        }
        if ($window.confirm(`Are you sure you want to reschedule ${pluralizeInvoice()} to ${dateLabel}?`)) {
          return InvoiceRescheduleService.bulkReschedule($scope.selectedInvoices, rescheduleDate, dateLabel, reloadTable, $scope.featureNames);
        }
      };
      $scope.isBulkRescheduleFromDateAvailable = function(invoice) {
        return $scope.permissions.manage_payment_status && invoice.status === 'upcoming' && invoice.realignable && gym.active_payment_plan_memberships_exist && moment(invoice.due_date).isAfter($scope.gym.today);
      };
      $scope.bulkRescheduleFromDate = function(invoice) {
        var params;
        params = {
          contactType: $scope.contactsType(invoice.contact_type),
          contactId: invoice.contact_id,
          invoice_id: invoice.invoice_id,
          from_contact_page: !!$scope.contactId || void 0
        };
        return $state.go('gym.contacts.membershipRealignments', params);
      };
      $scope.showInvoicePlanBulkRescheduleModal = function(invoice) {
        return ReactModal.open({
          component: 'InvoicePlanBulkRescheduleModal',
          props: {
            invoice: invoice
          }
        });
      };
      $scope.setOrder = function(field) {
        var orderBy;
        if ($scope.isContactPage()) {
          return;
        }
        orderBy = {};
        orderBy[field] = $scope.orderBy[field] === 'asc' ? 'desc' : 'asc';
        $scope.orderBy = orderBy;
        return $scope.tableParams.reload();
      };
      $scope.markAsPaid = function(invoice, type) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/invoices/mark_as_paid_modal.html.slim'),
          controller: 'MarkAsPaidCtrl',
          resolve: {
            invoice: function() {
              return invoice;
            },
            type: function() {
              return type;
            }
          }
        });
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      $scope.skip = function(invoice) {
        return SkipInvoiceService.skip(invoice).then(function() {
          return reloadTable();
        });
      };
      $scope.adminChangeToPaid = function(invoice) {
        var message;
        message = "WARNING: a pending payment's status should only be changed if there is no way to get the status back from the provider normally. Once this change has been made, Clubworx will no longer be able to query the payment provider for this payment's status.";
        if ($window.confirm(message)) {
          return invoice.doPUT({}, 'admin_status_change_paid').then(function() {
            flash.success = 'Invoice marked as paid';
            return reloadTable();
          }, function() {
            return flash.error = "Request could not be completed. Please try again";
          });
        }
      };
      $scope.adminChangeToFailed = function(invoice) {
        var message;
        message = "WARNING: a pending payment's status should only be changed if there is no way to get the status back from the provider normally. Once this change has been made, Clubworx will no longer be able to query the payment provider for this payment's status.";
        if ($window.confirm(message)) {
          return invoice.doPUT({}, 'admin_status_change_failed').then(function() {
            flash.success = 'Invoice marked as failed';
            return reloadTable();
          }, function() {
            return flash.error = "Request could not be completed. Please try again";
          });
        }
      };
      $scope.isChangeAmountAvailable = function(invoice) {
        return $scope.permissions.manage_payment_status && $scope.permissions.adjust_payment_amounts && !invoice.realtime && ((invoice.payment_plan_version === 'v1_payment_plan' && invoice.status === 'upcoming' && moment($scope.gym.today).isBefore(invoice.due_date)) || (invoice.payment_plan_version === 'v2_invoice_plan' && ['upcoming', 'process_manually', 'skipped', 'failed'].includes(invoice.status)));
      };
      $scope.isSplitPaymentAvailable = function(invoice) {
        var ref;
        return ((ref = invoice.status) === 'upcoming' || ref === 'failed' || ref === 'process_manually') && $scope.permissions.adjust_payment_amounts && invoice.payment_plan_version === 'v2_invoice_plan' && invoice.payment_type === 'regular_payment' && !invoice.realtime;
      };
      $scope.isApplyCreditAvailable = function(invoice) {
        return $scope.permissions.adjust_payment_credit && $scope.creditVouchersAvailable && ((invoice.payment_plan_version === 'v1_payment_plan' && invoice.status === 'upcoming') || (invoice.payment_plan_version === 'v2_invoice_plan' && ['upcoming', 'failed'].includes(invoice.status)));
      };
      $scope.isRemoveCreditAvailable = function(invoice) {
        var ref;
        return $scope.creditVouchersAvailable && invoice.credit_applied_amount > 0 && ((ref = invoice.status) !== 'pending' && ref !== 'submitted') && $scope.permissions.adjust_payment_credit && invoice.paid_with_noun !== 'Credit balance';
      };
      $scope.isChangeStatusAsAdminAvailable = function(invoice) {
        return invoice.status === 'pending' && MasqueradingService.isMasquerading();
      };
      $scope.isRefund = function(invoice) {
        var ref;
        return (ref = invoice.payment_type) === 'full_refund' || ref === 'partial_refund';
      };
      $scope.isRefundAvailable = function(invoice) {
        return invoice.status === 'paid' && !invoice.non_debit_payment && invoice.row_type !== 'sale' && $scope.permissions.adjust_payment_amounts && !$scope.isRefund(invoice);
      };
      $scope.isDeleteAvailable = function(invoice) {
        return ($scope.permissions.adjust_payment_amounts && invoice.non_debit_payment) || ($scope.permissions.view_pos_sales && invoice.sale_id && !invoice.invoice_id);
      };
      $scope.isReceiptAvailable = function(invoice) {
        return invoice.status === 'paid' && invoice.membership_send_invoice_receipts;
      };
      $scope.isPosReceiptAvailable = function(invoice) {
        return invoice.sale_id && !invoice.membership_send_invoice_receipts && !invoice.non_debit_payment;
      };
      $scope.isRescheduleAvailable = function(invoice) {
        return $scope.permissions.manage_payment_status && !invoice.realtime && ($scope.isInvoiceEditable(invoice) || invoice.non_debit_payment);
      };
      $scope.isStatusChangeAvailable = function(invoice) {
        return $scope.isInvoiceEditable(invoice) && !invoice.non_debit_payment;
      };
      $scope.isMarkAsPaidAvailable = function(invoice) {
        if (!$scope.permissions.manage_payment_status) {
          return false;
        }
        return $scope.isStatusChangeAvailable(invoice) || invoice.status === 'skipped';
      };
      $scope.isBulkStatusChangeAvailable = function() {
        return $scope.selectedInvoices.length && $scope.permissions.manage_payment_status && !_.find($scope.selectedInvoices, function(invoice) {
          return invoice.non_debit_payment;
        }) && !_.find($scope.selectedInvoices, function(invoice) {
          return invoice.realtime;
        });
      };
      $scope.isAdjustmentAvailable = function() {
        var ref;
        return $scope.permissions.adjust_payment_amounts && $scope.isContactPage() && ((ref = $scope.contact.memberships) != null ? ref.length : void 0);
      };
      $scope.isRetryNowAvailable = function(invoice) {
        return $scope.permissions.manage_payment_status && $scope.gym.realtime_failure_retries_enabled && !invoice.realtime && invoice.status === 'failed';
      };
      $scope.isProcessNowAvailable = function(invoice) {
        return moment(invoice.due_date).isSameOrBefore(moment().add(30, 'days'), 'day') && $scope.permissions.manage_payment_status && $scope.gym.realtime_failure_retries_enabled && invoice.status === 'upcoming';
      };
      $scope.isMarkAsFailedAvailable = function(invoice) {
        return !$scope.gym.has_payment_provider && invoice.status === 'process_manually' && $scope.permissions.manage_payment_status;
      };
      $scope.checkPaymentStatusAvailable = function(invoice) {
        return invoice.can_trigger_individual_status_check && MasqueradingService.isMasquerading();
      };
      $scope.fetchEzidebitPaymentDetailsAvailable = function(invoice) {
        return MasqueradingService.isMasquerading() && invoice.payment_provider_name === 'Ezidebit' && invoice.provider_payment_reference;
      };
      $scope.markAsFailed = function(invoice) {
        var url;
        if ($window.confirm("Are you sure you want to mark this invoice as failed?")) {
          url = `/gyms/${$scope.gym.id}/invoices/${invoice.id}/mark_failed`;
          return $http.put(url).then(function() {
            flash.success = 'Invoice marked as failed';
            return reloadTable();
          }, function() {
            return flash.error = "Request could not be completed. Please try again";
          });
        }
      };
      $scope.retryNow = function(invoice) {
        var modalInstance, paymentProviderEndpoint;
        if (invoice.realtime === true) {
          modalInstance = $modal.open({
            template: require('templates/gyms/invoices/deny_failed_payment_retry.modal.html.slim'),
            controller: 'DenyFailedPaymentRetryCtrl'
          });
        } else {
          if ($scope.gym.uses_stripe) {
            paymentProviderEndpoint = 'stripe';
          } else if ($scope.gym.uses_ezidebit) {
            paymentProviderEndpoint = 'ezidebit';
          } else {
            return;
          }
          modalInstance = $modal.open({
            template: require('templates/gyms/invoices/retry_failed_payment_modal.html.slim'),
            controller: 'RetryFailedPaymentCtrl',
            resolve: {
              invoice: function() {
                return invoice;
              },
              paymentMethods: ["Restangular", "$stateParams", function(Restangular, $stateParams) {
                return Restangular.one('gyms', $stateParams.gymId).one('contacts', invoice.contact_id).all(paymentProviderEndpoint).getList();
              }]
            }
          });
        }
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      $scope.processNow = function(invoice) {
        var modalInstance, paymentProviderEndpoint;
        if ($scope.gym.uses_stripe) {
          paymentProviderEndpoint = 'stripe';
        } else if ($scope.gym.uses_ezidebit) {
          paymentProviderEndpoint = 'ezidebit';
        } else {
          return;
        }
        modalInstance = $modal.open({
          template: require('templates/gyms/invoices/process_payment_modal.html.slim'),
          controller: 'ProcessPaymentCtrl',
          resolve: {
            invoice: function() {
              return invoice;
            },
            paymentMethods: ["Restangular", "$stateParams", function(Restangular, $stateParams) {
              return Restangular.one('gyms', $stateParams.gymId).one('contacts', invoice.contact_id).all(paymentProviderEndpoint).getList();
            }]
          }
        });
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      $scope.checkPaymentStatus = function(invoice) {
        var url;
        if (window.confirm("Are you sure?")) {
          url = `/gyms/${$scope.gym.id}/invoices/${invoice.id}/trigger_status_check`;
          return $http.put(url).then(function() {
            flash.success = "Payment status check successful";
            return reloadTable();
          }, function() {
            return flash.error = "An error occurred while checking payment status";
          });
        }
      };
      $scope.fetchEzidebitPaymentDetails = function(invoice) {
        return ReactModal.open({
          component: 'FetchEzidebitPaymentDetailsModal',
          props: {
            invoice: invoice
          }
        });
      };
      $scope.isDelayedLinkVisible = function(invoice) {
        var ref;
        return $scope.gym.uses_submitted_payment_status && invoice.charged_on && moment(invoice.charged_on).isAfter(invoice.due_date) && !((ref = invoice.status) === 'upcoming' || ref === 'skipped');
      };
      $scope.isMoreInfoAvailable = function(invoice) {
        var ref;
        return !(((ref = invoice.status) === 'skipped') || invoice.non_debit_payment);
      };
      $scope.showMoreInfo = function(invoice) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/gyms/invoices/invoice_info_modal.html.slim'),
          resolve: {
            invoice: function() {
              return invoice;
            },
            reloadTable: function() {
              return reloadTable;
            },
            refund: function() {
              return $scope.isRefund(invoice);
            }
          },
          controller: 'InvoiceInfoCtrl'
        });
      };
      $scope.canSendMessage = function(invoice) {
        return $scope.permissions.send_comms && invoice.contact_id && !$scope.isRefund(invoice);
      };
      $scope.sendMessage = function(invoice) {
        return Contacts.get(`${invoice.contact_id}`).then(function(invoiceContact) {
          var params, recipient;
          recipient = {
            id: invoice.contact_id,
            name: invoice.contact_name,
            type: invoiceContact.type,
            status: invoiceContact.status
          };
          bulkMessageService.setRecipients([recipient]);
          params = {
            invoiceId: invoice.id
          };
          if ($stateParams.contactId) {
            params.from = 'contactInvoices';
            params.fromContactId = $stateParams.contactId;
            params.fromContactType = $stateParams.contactType;
          } else {
            params.from = 'invoices';
          }
          return $state.go('gym.bulkMessages.new', params);
        });
      };
      $scope.addAdjustment = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/invoices/add_adjustment_modal.html.slim'),
          controller: 'AddAdjustmentCtrl',
          resolve: {
            contact: function() {
              return $scope.contact;
            }
          }
        });
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      $scope.addCredit = function() {
        return MessageService.message({
          title: 'Add credit to contact',
          message: ["<strong>Credit vouchers</strong> can be used to apply a credit balance to a customer, which can then be used to pay for (or reduce the chargeable amount of) selected payments.", 'Click "Add Credit" below to add a voucher for this contact now.'],
          bindHtml: true,
          confirmButtonText: 'Add Credit',
          cancelButtonText: 'Cancel'
        }).then(function() {
          return $scope.addCreditVoucher();
        });
      };
      $scope.isCancelAvailable = function(invoice) {
        return $scope.permissions.manage_payment_status && invoice.status === 'submitted';
      };
      $scope.cancelInvoice = function(invoice) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/invoices/cancel_invoice.html.slim'),
          resolve: {
            invoice: function() {
              return invoice;
            }
          },
          controller: 'InvoiceCancellationCtrl'
        });
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      remove = function(invoice) {
        if (invoice.sale_id && !invoice.invoice_id) {
          return $http.delete(`gyms/${gymId}/pos/sales/${invoice.sale_id}`);
        } else {
          return invoice.remove();
        }
      };
      $scope.delete = function(invoice) {
        if ($window.confirm('Are you sure you want to delete this invoice?')) {
          loadingAnimation.show();
          return remove(invoice).then(function() {
            flash.success = 'Invoice deleted';
            return reloadTable();
          });
        }
      };
      $scope.invoiceReceiptLink = function(invoice) {
        return `/gyms/${gymId}/invoices/${invoice.id}`;
      };
      $scope.posReceiptLink = function(invoice) {
        return `/gyms/${gymId}/pos/sales/${invoice.sale_id}/receipt`;
      };
      $scope.resendInvoiceEmail = function(invoice) {
        var url;
        if ($window.confirm('Are you sure you want to re-send this payment receipt?')) {
          url = `/gyms/${$scope.gym.id}/invoices/${invoice.id}/resend_receipt_email`;
          return $http.put(url).then(function(response) {
            var email;
            email = response.data.contact_email;
            return flash.success = `Invoice receipt email sent to: ${email}`;
          }, function() {
            return flash.error = 'An error occurred sending invoice email to member.';
          });
        }
      };
      $scope.contactsType = function(type) {
        return `${underscored(type)}s`;
      };
      $scope.changeAmount = function(invoice) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/invoices/change_amount_modal.html.slim'),
          resolve: {
            invoice: function() {
              return invoice;
            },
            currency: function() {
              return $scope.currency_symbol;
            }
          },
          controller: 'PaymentAdjustmentsCtrl'
        });
        return modalInstance.result.then(function(data) {
          return reloadTable();
        });
      };
      $scope.splitPayment = function(invoice) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'SplitPaymentModal',
          props: {
            invoice: invoice
          }
        });
        return modalInstance.then(function(data) {
          $scope.$emit('contact:reload');
          return reloadTable();
        });
      };
      $scope.applyCredit = function(invoice) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'ApplyCreditModal',
          props: {
            invoice: invoice
          }
        });
        return modalInstance.then(function(data) {
          $scope.$emit('contact:reload');
          return reloadTable();
        });
      };
      $scope.removeCredit = function(invoice) {
        return ReactModal.open({
          component: 'RemoveCreditModal',
          props: {
            invoice: invoice
          }
        });
      };
      $scope.refund = function(invoice) {
        var modalInstance;
        if ($scope.gym.uses_ezidebit && $scope.gym.refunds_enabled && invoice.payment_provider_name === 'Ezidebit') {
          return ReactModal.open({
            component: 'EzidebitRefundModal',
            props: {
              invoice: invoice
            }
          }).then(function(data) {
            return reloadTable();
          });
        } else {
          modalInstance = $modal.open({
            template: require('templates/gyms/invoices/invoice_refund_modal.html.slim'),
            resolve: {
              invoice: function() {
                return invoice;
              },
              currency: function() {
                return $scope.currency_symbol;
              }
            },
            controller: 'InvoiceRefundCtrl'
          });
          return modalInstance.result.then(function(data) {
            return reloadTable();
          });
        }
      };
      $scope.isRevertPaidAvailable = function(invoice) {
        return invoice.revertable_from_paid && $scope.permissions.manage_payment_status;
      };
      $scope.isRevertSkippedAvailable = function(invoice) {
        return invoice.revertable_from_skipped && $scope.permissions.manage_payment_status;
      };
      $scope.revertPaidToUpcoming = function(invoice) {
        var message;
        message = invoice.paid_with === 'paid_with_credit' ? `This will change payment ${invoice.invoice_number_base} back to Upcoming.\nNote: because this payment was paid with credit, the credit balance will be refunded to the contact as part of this change.` : `This will change payment ${invoice.invoice_number_base} back to Upcoming.`;
        if ($window.confirm(message)) {
          return invoice.doPUT({}, 'revert_paid').then(function(response) {
            reloadTable();
            return flash.success = "Payment change successful";
          });
        }
      };
      $scope.revertSkippedToUpcoming = function(invoice) {
        var message;
        message = `This will change payment ${invoice.invoice_number_base} back to Upcoming.`;
        if ($window.confirm(message)) {
          return invoice.doPUT({}, 'revert_skipped').then(function(response) {
            reloadTable();
            return flash.success = "Payment change successful";
          });
        }
      };
      $scope.getCsv = function() {
        var exportPath, params, serializedParams, url;
        GTMService.trackPage('Payments', 'Export');
        params = {
          filters: angular.extend({}, $scope.filters, buildDateFiltersObj()),
          sorting: $scope.orderBy
        };
        if ($scope.contactId) {
          params.contact_id = $scope.contactId;
        }
        if ($scope.familyContact) {
          params.family = true;
        }
        serializedParams = angular.element.param(params);
        exportPath = Invoices.all('export').getRestangularUrl();
        url = `${exportPath}.csv?${serializedParams}`;
        $window.open(url, '_blank');
        return true;
      };
      $scope.showPaymentProviderNotice = !$scope.gym.has_payment_provider && !CwStorage.getItem('hidePaymentProviderNotice');
      $scope.hidePaymentProviderNotice = function() {
        CwStorage.setItem('hidePaymentProviderNotice', true);
        return $scope.showPaymentProviderNotice = false;
      };
      $scope.isInvoiceEditable = function(invoice) {
        var ref;
        return $scope.permissions.manage_payment_status && !invoice.realtime && (((ref = invoice.status) === 'upcoming' || ref === 'failed' || ref === 'process_manually') || invoice.non_debit_payment);
      };
      $scope.isInvoiceSelectable = function(invoice) {
        var ref;
        if ($scope.isContactPage()) {
          return $scope.permissions.manage_payment_status && !invoice.realtime && ((ref = invoice.status) === 'upcoming' || ref === 'failed' || ref === 'process_manually');
        } else {
          return $scope.isInvoiceEditable(invoice);
        }
      };
      $scope.rescheduleMinDate = function(invoice) {
        return $scope.gym.today;
      };
      defaultFilters = {
        membership_plan_ids: [],
        location_ids: [],
        category_ids: [],
        sources: [],
        payment_method: null,
        refunds_only: false,
        exclude_refunds: false,
        search: ''
      };
      $scope.paymentStatuses.forEach(function(status) {
        return defaultFilters[status] = true;
      });
      if ((ref = $stateParams.status) === 'failed' || ref === 'paid') {
        $scope.paymentStatuses.forEach(function(status) {
          return defaultFilters[status] = false;
        });
        defaultFilters[$stateParams.status] = true;
      }
      storedFilters = JSON.parse(CwStorage.getItem('invoicesListFilters'));
      cleanedFilters = _.omit(storedFilters, 'search');
      if ((ref1 = $stateParams.status) === 'failed' || ref1 === 'paid') {
        $scope.filters = defaultFilters;
      } else if (storedFilters && !$scope.isContactPage()) {
        $scope.filters = _.defaults(cleanedFilters, defaultFilters);
      } else {
        $scope.filters = defaultFilters;
      }
      $scope.clearSelectedPreset = function() {
        return $scope.selectedPresetFilter = '';
      };
      $scope.setFilters = function(newFilters, params, skipStorage) {
        if (!(params != null ? params.fromPreset : void 0)) {
          $scope.clearSelectedPreset();
        }
        angular.extend($scope.filters, newFilters);
        return onFiltersChanged(skipStorage);
      };
      onFiltersChanged = function(skipStorage) {
        var filtersToStore;
        if ($scope.isContactPage() || skipStorage || $stateParams.dashletDates) {
          return;
        }
        filtersToStore = _.omit($scope.filters, 'search');
        return CwStorage.setItem('invoicesListFilters', JSON.stringify(filtersToStore));
      };
      $scope.resendPosSaleReceipt = function(invoice) {
        return $modal.open({
          template: require('templates/gyms/pos/sales/resend.html.slim'),
          controller: 'ResendSaleModalCtrl',
          resolve: {
            sale: ["Sales", function(Sales) {
              return Sales.get(invoice.sale_id).then(function(sale) {
                var ref2;
                sale.customer_email = (ref2 = sale.customer_attributes) != null ? ref2.email : void 0;
                return sale;
              });
            }]
          }
        });
      };
      getSources = function() {
        var sources;
        sources = [
          FeatureAvailabilityService.isAvailable('waivers') && {
            id: 'waiver',
            name: 'Waiver'
          },
          FeatureAvailabilityService.isAvailable('pos') && {
            id: 'pos',
            name: 'POS sale'
          },
          $scope.gym.book_and_pay_enabled && {
            id: 'realtime',
            name: 'Book & Pay / Realtime'
          },
          {
            id: 'kiosk',
            name: 'Kiosk purchase'
          },
          FeatureAvailabilityService.isAvailable('sequences') && {
            id: 'sequence',
            name: featureNames.SEQUENCE
          },
          FeatureAvailabilityService.isAvailable('grading_events') && {
            id: 'grading_event',
            name: 'Grading event fee'
          },
          {
            id: 'booking_cancel_fee',
            name: 'Booking late-cancel fee'
          },
          {
            id: 'membership_cancel_fee',
            name: 'Membership cancel fee'
          },
          $scope.gym.has_payment_provider && {
            id: 'failure_fee',
            name: 'Failed payment fee'
          },
          {
            id: 'ndp',
            name: 'Non-debit adjustment'
          },
          {
            id: 'membership_general',
            name: 'Membership added by user'
          },
          $scope.gym.mobile_app_enabled && {
            id: 'mobile_app',
            name: 'Mobile app'
          }
        ];
        return _.compact(sources);
      };
      $scope.sources = getSources();
      $scope.reloadTable = reloadTable = function() {
        return $scope.tableParams.reload();
      };
      getTotalAmount = function(invoices) {
        return _.reduce(invoices, function(sum, invoice) {
          if (invoice.amount) {
            return sum + parseFloat(invoice.amount);
          } else {
            return sum;
          }
        }, 0);
      };
      getCountOnPage = function(invoices) {
        return _.filter(invoices, function(invoice) {
          return invoice.amount;
        }).length;
      };
      $scope.orderBy = {
        due_date: 'desc'
      };
      $scope.$watch('filters', (function() {
        return $scope.tableParams.page(1);
      }), true);
      formatCurrency = function(val) {
        return $filter('cwCurrency')(val, $scope.currency_symbol);
      };
      return $scope.tableParams = TableService.init({
        count: 25,
        filters: $scope.filters,
        getData: function(resolve, params, beforeLoad) {
          var previewParams, requestParams;
          loadingAnimation.show();
          $scope.selectedInvoices = [];
          $scope.isAllInvoicesSelected = false;
          if ($stateParams.dashletDates) {
            if (dashletRequestInFlight) {
              loadingAnimation.hide();
              previewParams = params.url();
              angular.extend(previewParams, buildDateFilters(), stringifyParams({
                sorting: $scope.orderBy
              }));
              beforeLoad(previewParams);
              resolve([]);
              return;
            }
            dashletRequestInFlight = true;
          }
          requestParams = params.url();
          requestParams['filters[membership_plan_ids][]'] = requestParams['filters[membership_plan_ids]'];
          requestParams['filters[membership_plan_ids]'] = void 0;
          requestParams['filters[location_ids][]'] = requestParams['filters[location_ids]'];
          requestParams['filters[location_ids]'] = void 0;
          requestParams['filters[category_ids][]'] = requestParams['filters[category_ids]'];
          requestParams['filters[category_ids]'] = void 0;
          requestParams['filters[sources][]'] = requestParams['filters[sources]'];
          requestParams['filters[sources]'] = void 0;
          if ($scope.contactId) {
            requestParams.contact_id = $scope.contactId;
          }
          if ($scope.familyContact) {
            requestParams.family = true;
          }
          angular.extend(requestParams, buildDateFilters(), stringifyParams({
            sorting: $scope.orderBy
          }));
          beforeLoad(requestParams);
          return Invoices.getList(requestParams).then(function(data) {
            var invoices;
            if ($stateParams.dashletDates) {
              dashletFirstLoadDone = true;
            }
            if ($stateParams.dashletDates) {
              dashletRequestInFlight = false;
            }
            loadingAnimation.hide();
            params.total(data.meta.total);
            $scope.total = data.meta.total;
            $scope.meta = data.meta;
            $scope.totalAmount = getTotalAmount(data);
            $scope.countOnPage = getCountOnPage(data);
            $scope.histories = _.mapObject(data.meta.histories, function(val) {
              return val.map(function(item) {
                return angular.extend({
                  id: item.data.id,
                  type: item.data.type
                }, item.data.attributes);
              });
            });
            invoices = _.map(data, function(invoice) {
              invoice.id || (invoice.id = _.uniqueId('suspension_'));
              invoice.rescheduled_due_date = invoice.due_date;
              return invoice;
            });
            $scope.totalAmountLabel = `${formatCurrency($scope.totalAmount)} of ${formatCurrency($scope.meta.amount_total)}`;
            $scope.totalAmountCurrentPage = formatCurrency($scope.totalAmount);
            $scope.totalAmountAllPages = formatCurrency($scope.meta.amount_total);
            $scope.countOnPageLabel = `${$scope.countOnPage ? '1 - ' : ''}${$scope.countOnPage}`;
            $scope.selectAllAvailable = _.find(invoices, $scope.isInvoiceSelectable);
            buildPresetFilterOptions();
            return resolve(invoices);
          }, function() {
            if ($stateParams.dashletDates) {
              dashletRequestInFlight = false;
            }
            loadingAnimation.hide();
            return flash.error = 'Request couldn\'t be completed. Please try again';
          });
        }
      });
    }]
  };
});
